// ============================================================================
// TOP TREES - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'top-trees',
  name: 'Top Trees',
  category: 'Graphs',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A dynamic data structure for maintaining a tree under operations like link, cut, and subtree queries. It generalizes the Link-Cut Tree and can handle more complex tree operations efficiently.'
};
